import { detach, getParentOfType } from 'mobx-state-tree';
import { v4 } from 'uuid';
import schema, { generateType } from './Schema';
export const AccessGroupDefinition = generateType(schema.getModel('accessGroupDefinition'));
export const CrawlConfig = generateType(schema.getModel('crawlConfig')).actions((self) => ({
    addChange() {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getParentOfType(self, Organization).addChange();
    },
}));
export const Organization = generateType(schema.getModel('organization'))
    .views((self) => ({
    get isAIServiceUnavailable() {
        return self.clientAIStatus === 'Disabled' || self.clientAIStatus === 'Rate Limited';
    },
    getCrawlConfig(crawlID) {
        return self.crawlConfigs.find((c) => c.id === crawlID);
    },
}))
    .actions((self) => ({
    log() {
        console.log(JSON.stringify(self));
    },
    addAccessGroup(newGroup) {
        self.accessGroups.push(newGroup);
    },
    removeAccessGroup(groupToRemove) {
        self.accessGroups.remove(groupToRemove);
    },
    addCrawlConfig(name) {
        const newCrawl = CrawlConfig.create({
            id: v4(),
            name,
        });
        self.crawlConfigs.push(newCrawl);
        self.addChange();
        return newCrawl;
    },
    deleteCrawlConfig(crawlConfig) {
        // self.crawlConfigs.remove(crawlConfig);
        detach(crawlConfig);
        self.addChange();
    },
}));
export const User = generateType(schema.getModel('user'))
    .actions((self) => ({
    // This is an auto-generated example action.
    log() {
        console.log(JSON.stringify(self));
    },
}));
export const UserOrganization = generateType(schema.getModel('userOrganization'))
    .actions((self) => ({
    // This is an auto-generated example action.
    log() {
        console.log(JSON.stringify(self));
    },
}));
export const ClientAi = generateType(schema.getModel('clientAi'))
    .actions((self) => ({
    // This is an auto-generated example action.
    log() {
        console.log(JSON.stringify(self));
    },
}));
export const syncOrganizationToCognitoGQL = /* GraphQL */ `
  mutation SyncOrganizationToCognito($organizationID: String) {
    syncOrganizationToCognito(organizationID: $organizationID)
  }
`;
export const deployOrganizationGql = `
  mutation DeployOrganization(
    $organizationID: String!
  ) {
    deployOrganization(
      organizationID: $organizationID
    ) {
      ${schema.getGqlPropertyList('organization', false, true, false).join(' ')}
    }
  }
`;
export const getGoogleAccessTokenGQL = ( /* GraphQL */`
  mutation GetGoogleAccessToken(
    $authorizationCode: String,
    $redirectUri: String,
    $organizationID: String!
  ) {
    getGoogleAccessToken(
      authorizationCode: $authorizationCode,
      redirectUri: $redirectUri,
      organizationID: $organizationID
    ) {
      statusCode
      message
      accessToken
    }
  }
`);
export const getGoogleSyncConfigGQL = ( /* GraphQL */`
  query GetGoogleSyncConfig(
    $organizationID: String!
  ) {
    getGoogleSyncConfig(
      organizationID: $organizationID
    ) {
      statusCode
      message
      config
    }
  }
`);
export const startCrawlGQL = ( /* GraphQL */`
  mutation StartCrawl(
    $organizationID: ID!
    $crawlID: ID!
  ) {
    startCrawl(
      organizationID: $organizationID
      crawlID: $crawlID
    ) {
      statusCode
      message
      organization {
        ${schema.getGqlPropertyList('organization', false, true, false).join(' ')}
      }
    }
  }
`);
export const getCrawlStatusGQL = ( /* GraphQL */`
  query GetCrawlStatus(
    $organizationID: ID!
    $crawlID: ID!
  ) {
    getCrawlStatus(
      organizationID: $organizationID
      crawlID: $crawlID
    ) {
      statusCode
      message
      organization {
        ${schema.getGqlPropertyList('organization', false, true, false).join(' ')}
      }
    }
  }
`);
export const getCrawledUrlsGQL = ( /* GraphQL */`
  query GetCrawledUrls(
    $organizationID: ID!
    $crawlID: ID!
  ) {
    getCrawledUrls(
      organizationID: $organizationID
      crawlID: $crawlID
    ) {
      statusCode
      message
    }
  }
`);
export const checkStatusGQL = (isPortalApi) => ( /* GraphQL */`
  query CheckStatus(
    ${isPortalApi ? '' : '$organizationID: String!, '}
    $items: [StatusItem]!
  ) {
    checkStatus(
      ${isPortalApi ? '' : 'organizationID: $organizationID, '}
      items: $items
    ) {
      type
      id
      asset {
        ${schema.getGqlPropertyList('asset', isPortalApi, true, false).join(' ')}
      }
      course {
        ${schema.getGqlPropertyList('course', isPortalApi, true, false).join(' ')}
      }
      organization {
        ${schema.getGqlPropertyList('organization', isPortalApi, true, false).join(' ')}
      }
      __typename
    }
  }
`);
//# sourceMappingURL=OrganizationModel.js.map